import { NavLink } from 'react-router'
import { FiArrowRight } from 'react-icons/fi'
import { Container, Reveal, RevealGroup, HoverText } from '@/components/common'
import { ROUTES } from '@/constants/routes'
import { articles } from '@/constants/news'

const categoryRoute: Record<string, string> = {
  Programmes: ROUTES.PROGRAMMES,
  Partnerships: ROUTES.PARTNER,
  Events: ROUTES.GALLERY,
}

export const News = () => {
  return (
    <section className="bg-white py-24 lg:py-32">
      <Container>
        <div className="flex flex-col gap-6 sm:flex-row sm:items-end sm:justify-between">
          <div className="max-w-xl">
            <Reveal variant="up" delay={100}>
              <h2 className="mt-7 text-4xl font-bold leading-[1.05] tracking-[-0.02em] text-ibon-dark sm:text-5xl lg:text-6xl">
                Latest News <span className="text-ibon-dark/30">and Opportunities</span>
              </h2>
            </Reveal>
            <Reveal variant="up" delay={200}>
              <p className="mt-6 text-lg leading-relaxed text-text-muted">
                Stay informed about programme launches, events, partnerships, publications, funding
                opportunities, and organisational updates.
              </p>
            </Reveal>
          </div>

          <Reveal variant="fade" delay={250}>
            <NavLink
              to={ROUTES.IMPACT}
              className="group inline-flex shrink-0 items-center gap-2 rounded-full border border-border px-7 py-3.5 text-xs font-semibold uppercase tracking-[0.2em] text-ibon-dark transition-colors hover:border-ibon-sky hover:text-ibon-sky"
            >
              <HoverText text="View All News" />
              <FiArrowRight
                className="transition-transform duration-300 group-hover:translate-x-1"
                size={15}
              />
            </NavLink>
          </Reveal>
        </div>

        <RevealGroup className="mt-14 grid gap-8 md:grid-cols-3" step={110}>
          {articles.map((article) => (
            <article key={article.title} className="group flex h-full flex-col">
              <div className="overflow-hidden">
                <img
                  src={article.image}
                  alt={article.title}
                  className="aspect-4/3 w-full object-cover transition-transform duration-700 group-hover:scale-105"
                  loading="lazy"
                />
              </div>
              <div className="flex flex-1 flex-col pt-6">
                <span className="text-xs font-semibold uppercase tracking-[0.2em] text-ibon-sky">
                  {article.category}
                </span>
                <h3 className="mt-3 flex-1 text-xl font-bold leading-snug text-ibon-dark">
                  {article.title}
                </h3>
                <NavLink
                  to={categoryRoute[article.category] ?? ROUTES.IMPACT}
                  className="group/link mt-6 inline-flex items-center gap-2 text-xs font-semibold uppercase tracking-[0.2em] text-ibon-dark transition-colors hover:text-ibon-sky"
                >
                  <HoverText text="Read More" />
                  <FiArrowRight
                    className="transition-transform duration-300 group-hover/link:translate-x-1"
                    size={14}
                  />
                </NavLink>
              </div>
            </article>
          ))}
        </RevealGroup>
      </Container>
    </section>
  )
}
